import type { TkDict } from "./types";
import layout from "./layout";
import home from "./home";
import catalog from "./catalog";
import detail from "./detail";
import editor from "./editor";
import checkout from "./checkout";
import success from "./success";
import dashboard from "./dashboard";
import auth from "./auth";
import pages from "./pages";

const parts: TkDict[] = [layout, home, catalog, detail, editor, checkout, success, dashboard, auth, pages];

const merge = (pick: (d: TkDict) => Record<string, string>) =>
  Object.assign({}, ...parts.map(pick)) as Record<string, string>;

export const tkDictionaries: TkDict = {
  uz: merge((d) => d.uz),
  ru: merge((d) => d.ru),
  en: merge((d) => d.en),
};
